<template>

    <button :class="[{'is-loading': loading}, { 'is-disabled': isDisabled }, type, size, 'button']">
        <span class="icon is-normal" v-if="icon!=''"><i :class="[icon ? icon : '']"></i></span>
        <slot name="next-to-icon"></slot>
        <slot name="button-text">
            <template v-if="name!=''">
                <lang :labelKey="name" class="buttonText"></lang>
            </template>
        </slot>
        <slot></slot>
    </button>

</template>

<script>

    export default {

        name: "customBtnComponent", 
        
        props: {
            name: {
                type: String,
                default: ''
            },
            size: {
                type: String,
                default: 'isLarge'
            },
            type: {
                type: String,
                default: 'default'
            },
            icon: {
                type: String,
                default: ''
            },
            loading: {
                type: Boolean,
                default: false
            },
            isDisabled: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>

    .button.small {
        width: auto;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .button.small .icon {
        font-size: inherit;
    }
    .button small {
        font-size: 8px;
    }

</style>
